import { useMetadata } from '#wa/composables/useMetadata'

export function pinotGrisGrigioFiltersToUrl(filters) {
  if (
    filters.length === 2 &&
    filters.every(
      (filter) =>
        filter.category === 'varietals' &&
        ['syrah', 'shiraz'].includes(filter.key),
    )
  ) {
    return `varietals/syrah-shiraz/`
  }
  return undefined
}

export function pinotGrisGrigioUrlToFilters({ route }) {
  const metadata = useMetadata()
  if (
    route.params.category !== 'varietals' ||
    route.params.slug !== 'pinot-gris-grigio' ||
    !metadata.searchFilters
  )
    return undefined
  return metadata.searchFilters.filter(
    (filter) =>
      filter.category === 'varietals' &&
      ['pinot-gris', 'pinot-grigio'].includes(filter.key),
  )
}
